module.exports = __webpack_public_path__ + "img/DateTimeRange.d51f3455.svg";